<template>
  <el-dialog title="修改密码" :visible.sync="updateDialog" width="600px"  v-show="updateDialog" append-to-body>
    <el-form  ref="updateElForm" :model="addRow" :rules="rules" label-width="120px" >
      <div class="hidden-input">
        <input type="text" class="form-control">
        <input type="password" class="form-control">
      </div>
      <!--      <el-form-item class="row" label="验证码" prop="code" >
              <el-input placeholder="验证码" v-model="addRow.code" class="w200"></el-input>
              <el-button slot="append" class="send-but" @click="sendCode()">{{sendObj.text}}</el-button>
              <br><span class="f12 c999 ml10">验证码将发送至您绑定的手机：{{user.mobile}}</span>
            </el-form-item>-->
      <el-form-item class="row" label="旧密码" prop="password" >
        <el-input  class="w300" type="password" v-model="addRow.password" auto-complete="new-password" placeholder="请输入旧密码"  ></el-input>
      </el-form-item>
      <el-form-item class="row" label="新密码" prop="newPassword">
        <el-input  class="w300" type="password" v-model="addRow.newPassword"  auto-complete="new-password" placeholder="请输入新密码"  ></el-input>
        <br>
        <span class="f12 c999 ml10">（字母、数字、特殊字符最少2种组合,长度6-16位）</span>
      </el-form-item>
      <el-form-item class="row" label="确认新密码" prop="newPasswordCheck">
        <el-input  class="w300" type="password" v-model="addRow.newPasswordCheck"  auto-complete="new-password"  placeholder="请再次输入新密码"  ></el-input>
      </el-form-item>
    </el-form>
    <div v-show="false">
      <button id="updateEle"> </button>
    </div>
    <span slot="footer" class="flex-e">
        <el-button @click="cancel()">取 消</el-button>
        <el-button  @click="updatePassword()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import '../../../static/plugin/jquery.form'
import '../../../static/plugin/jquery.jcryption.3.1.0'

export default {
  props:{
    value:{
      type:Boolean,
      default:false,
    }
  },
  name: "updatePass",
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (value.length < 6) {
          callback(new Error('新密码长度必须大于6'));
        }
        if (value.length > 16) {
          callback(new Error('新密码长度必须小于16'));
        }
        if (!this.pass.test(value)) {
          callback(new Error('新密码格式不正确,需要长度6-16,且由字母、数字、特殊字符最少2种组合'));
        }
        if (this.addRow.newPasswordCheck !== '') {
          this.$refs['updateElForm'].validateField('newPasswordCheck');
        }
        callback();
      }
    };
    let validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.addRow.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      pass: /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/,
      updateDialog: false,
      addRow: {code: '', newPassword: '',newPasswordCheck:''},
      rules: {
        password: [
          {required: true, message: '请输入旧密码', trigger: 'blur'},
        ],
        newPassword: [
          {validator: validatePass2, trigger: 'blur'}
        ],
        newPasswordCheck: [
          {validator: validatePass3, trigger: 'blur'}
        ],
      },
      sendObj:{text:"发送验证码",status:true,count:0,timer:0}
    }
  },
  watch:{
    value(n){
      if(n){
        this.openDialog();
      }
    }
  },
  mixins: [tableBase],
  methods: {
    updatePassword() {
      this.$refs['updateElForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/login/updatePassword",{password:this.addRow.password,newPassword:this.addRow.newPassword},()=>{
            this.message("修改成功");
            this.cancel();
          })
        }
      });
    },

    openDialog() {
      this.updateDialog = true;
    },
    cancel(){
      this.updateDialog =false;
      this.$emit("update:modelValue", false);
    },
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
.send-but{
  margin-left: 8px;
}
.flex-e{
  padding-bottom: 20px;
  margin-right: 10px;
}
</style>
